import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "./Card";

const constantData = [
  { id: "1", img: "./images/one.png" },
  { id: "2", img: "./images/two.png" },
  { id: "3", img: "./images/three.png" },
  { id: "4", img: "./images/four.png" },
  { id: "5", img: "./images/five.png" },
  { id: "6", img: "./images/six.png" },
  { id: "7", img: "./images/seven.png" },
  { id: "8", img: "./images/eight.png" },
];

const shuffleData = [
  ...constantData.sort(() => Math.random() - 0.5),
  ...constantData.sort(() => Math.random() - 0.5),
];

const CardWrapper = ({ players }) => {
  const [openCard, setOpenCard] = useState([]);
  const [matchedCard, setMatchedCard] = useState([]);
  const [playerTurn, setPlayersTurn] = useState("first");
  // const [disableTouch, setDisableTouch] = useState(false)
  const [isGameOver, setIsGameOver] = useState(false);
  const [points, setPoints] = useState([0, 0]);

  //open only that card which is matching
  useEffect(() => {
    const firstMatch = shuffleData[openCard[0]];
    const secondMatch = shuffleData[openCard[1]];

    if (
      secondMatch &&
      firstMatch.id === secondMatch.id &&
      !matchedCard.includes(firstMatch?.id)
    ) {
      setMatchedCard([...matchedCard, secondMatch.id]);
      //for increasing points
      if (playerTurn === "first") setPoints([points[0] + 1, points[1]]);
      if (playerTurn === "second") setPoints([points[0], points[1] + 1]);
    } else if (secondMatch && firstMatch.id !== secondMatch.id) {
      setPlayersTurn((pre) => (pre === "second" ? "first" : "second"));
      // setDisableTouch(true)
    }

    if (openCard.length === 2)
      setTimeout(() => {
        setOpenCard([]);
        // setDisableTouch(false)
      }, 800);

    if (matchedCard.length === constantData.length) setIsGameOver(true);
  }, [openCard]);

  return (
    <div className={`card_wrapper`}>
      <div
        className={`player one ${
          playerTurn === "first" && !isGameOver ? "hisTurn" : ""
        }`}
      >
        {players.first ? players.first : "UNKNOWN"}: <span>{points[0]}</span>
      </div>
      <div
        className={`player two ${
          playerTurn === "second" && !isGameOver ? "hisTurn" : ""
        }`}
      >
        {players.second ? players.second : "UNKNOWN"}: <span>{points[1]}</span>
      </div>
      <div className="card_board">
        {shuffleData.map((card, index) => {
          return (
            <Card
              key={index}
              index={index}
              img={card.img}
              id={card.id}
              flipCard={flipCard}
              openCard={openCard}
              matchedCard={matchedCard}
            />
          );
        })}
      </div>
      {isGameOver && (
        <div className="winner_container">
          {points[0] === points[1] ? (
            <h1>
              Game <span>tied</span>, Try again
            </h1>
          ) : (
            <h1>
              hurray{" "}
              <span>
                {points[0] > points[1] ? players.first : players.second}
              </span>{" "}
              won!!
            </h1>
          )}
          <Link to={"/"}>Restart</Link>
          {points[0] !== points[1] && (
            <>
              <div className="ballons"></div>
              <div className="stars "></div>
            </>
          )}
          <div className="dev">
        -Created With 💙 by HARSHAL MUKTE
      </div>
        </div>
      )}

<div className="dev">
        -Created With 💙 by HARSHAL MUKTE
      </div>
    </div>
  );

  function flipCard(index) {
    setOpenCard((pre) => [...pre, index]);
  }
};

export default CardWrapper;
